import React from 'react';
import { mergeClassLists } from 'tailwind-classlist';
import { classes } from './utils';

export default function Title({ className = '', ...props }) {
  return (
    <h2 className={mergeClassLists(classes.title, className)} {...props} />
  );
}
